import React, { FC } from 'react';
import { Box, Container, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';

interface WorkWithUsProps {
  title: string;
  text: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
}));

const WorkWithUs: FC<WorkWithUsProps> = ({ title, text }) => {
  const classes = useStyles();
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <Container fixed>
      <Box mt={isSmall ? 18 : 9} mb={isSmall ? 5 : 4}>
        <Typography variant={isSmall ? 'h2' : 'h4'} className={classes.title} data-aos="fade-up">
          {title}
        </Typography>
      </Box>
      <Typography variant="body1" color="textSecondary" data-aos="fade-up" data-aos-delay="200">
        {text}
      </Typography>
    </Container>
  );
};

export default WorkWithUs;
